// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/layout.scss
// module id = 7
// module chunks = 28